<template>
  <div class="goods-promotion">
    <second-menu-link-content>
      <template v-slot:header>
        <span>商品促销</span>
      </template>
      <template v-slot:content>
        <div class="goods-promotion-main">
          <div
            class="add-promotion"
            v-if="operationList.indexOf(operationsBtns.roleSaleSpecialManage)!==-1"
          >
            <el-button class="btn-blue" @click="addPromotion">新增促销</el-button>
            <el-button class="btn-blue setting" @click="openDialogVisible">促销配置</el-button>
          </div>
          <div class="search">
            <el-input
              v-model="name"
              class="white"
              @keyup.enter.native="searchPromotionList"
              placeholder="请输入商品名称"
            ></el-input>
            <el-button class="btn-blue" @click="searchPromotionList">搜索</el-button>
          </div>
          <div class="table-img">
            <el-table :data="tableData" style="width: 100%" v-loading="loading">
              <el-table-column prop="goodsName" label="商品名称" min-width="200">
                <template slot-scope="scope">
                  <p class="name">{{scope.row.goodsName}}</p>
                </template>
              </el-table-column>
              <el-table-column prop="time" label="促销时间" width="184"></el-table-column>
              <el-table-column prop="rule" label="促销规则" min-width="96"></el-table-column>
              <el-table-column prop="saleNumber" label="已售数量" min-width="96"></el-table-column>
              <el-table-column prop="limit" label="每人限购" min-width="96"></el-table-column>
              <el-table-column prop="scope" label="客户范围" min-width="96"></el-table-column>
              <el-table-column prop="weight" label="展示权重" min-width="96"></el-table-column>
              <el-table-column prop="statusValue" label="状态" min-width="96"></el-table-column>
              <el-table-column label="操作" min-width="180">
                <template slot-scope="scope">
                  <el-button
                    class="btn-text"
                    type="text"
                    @click="toPromotionGoodsDetailById(scope.row.id)"
                  >查看</el-button>
                  <!-- <el-button
                    v-if="operationList.indexOf(operationsBtns.roleSaleSpecialManage)!==-1"
                    class="btn-text"
                    type="text"
                    @click="toPromotionGoodsUpdateById(scope.row.id)"
                  >修改</el-button>-->
                  <template
                    v-if="operationList.indexOf(operationsBtns.roleSaleSpecialManage)!==-1 && scope.row.timeOut"
                  >
                    <el-button
                      v-if=" scope.row.status === 1"
                      class="btn-text"
                      type="text"
                      @click="changeStatus(scope.row)"
                    >停用</el-button>
                    <el-button
                      v-else
                      class="btn-text"
                      type="text"
                      @click="changeStatus(scope.row)"
                    >启用</el-button>
                  </template>
                  <el-button
                    v-if="operationList.indexOf(operationsBtns.roleSaleSpecialManage)!==-1"
                    class="btn-text"
                    type="text"
                    @click="deletePromotionGoods(scope.row.id)"
                  >删除</el-button>
                  <el-button
                    class="btn-text"
                    type="text"
                    @click="copy(scope.row.id)"
                  >复制</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination-tpl-container">
              <pagination-tpl
                :total="totalNum"
                :currentPage="currentPage"
                @queryChange="onQueryChange"
              ></pagination-tpl>
            </div>
          </div>
          <el-dialog title="促销配置" :visible.sync="dialogVisible" width="400px" top="25vh">
            <!-- 黑色的线条 -->
            <div class="border"></div>
            <el-form :model="formData" ref="formData" label-width="120px">
              <el-form-item label="是否执行等级价：">
                <el-radio-group v-model="formData.status">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item>
                <el-button class="btn-white" @click="cancel">取消</el-button>
                <el-button class="btn-blue" @click="sevePromotionStatus">保存</el-button>
              </el-form-item>
            </el-form>
          </el-dialog>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import { getDBOperationPermission } from "common/js/storage"; // 权限数据接口
import { formaTimeToSecond } from "common/js/util.js";
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import PaginationTpl from "base/PaginationTpl";
import DBMarketing from "models/db/marketing.js";
const dbMarketing = new DBMarketing();
export default {
  components: {
    SecondMenuLinkContent,
    PaginationTpl
  },
  data() {
    return {
      operationList: [], // 权限列表数据
      // 页面按钮--促销管理
      operationsBtns: {
        roleSaleSpecialManage: "ROLE_SALE_special_manage"
      },
      name: "",
      dialogVisible: false,
      formData: {
        status: 1
      },
      searchName: "",
      tableData: [],
      totalNum: 0,
      currentPage: 1,
      loading: true,
      copyId: null,   // 复制id
    };
  },
  activated() {
    this.copyId = null
    if (this.$route.params.change) {
      this.getPromotionList();
    }
  },
  created() {
    this.operationList = getDBOperationPermission();
    this.getPromotionList();
    this.getPromotionStatus();
  },
  methods: {
    addPromotion() {
      this.$router.push({
        path:"/admin/marketing/promotion/add-promotion",
        query: {
          copyId: this.copyId,
        }
      });
    },
    // 获取折上折
    getPromotionStatus() {
      dbMarketing.getDBPromotionDiscountStatus().then(res => {
        if (res.success) {
          this.formData.status = res.result;
        }
      });
    },
    // 获取促销列表
    getPromotionList() {
      let searchValue = this.searchName;
      let currentPage = this.currentPage;
      let options = {
        searchValue,
        currentPage
      }
      dbMarketing.getDBPromotionList(options).then(res => {
        if (res.success) {
          this.totalNum = res.result.totalNum;
          let arr = [];
          res.result.items.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.goodsName = value.goodsName;
            obj.time =
              formaTimeToSecond(value.beginTime) +
              "至" +
              formaTimeToSecond(value.endTime);
            let date = new Date().getTime();
            obj.timeOut = date < value.endTime;
            obj.rule = value.ruleType === 1 ? "直降" : "阶梯满减";
            obj.saleNumber = value.sumSaleNum;
            obj.limit = value.buyLimit === 0 ? "无" : value.buyLimit;
            obj.weight = value.weight;
            obj.scope = value.cusLabelName ? value.cusLabelName : "无";
            obj.status = value.status;
            obj.statusValue = value.status === 1 ? "开启" : "关闭";
            arr.push(obj);
          });
          this.tableData = arr;
          this.loading = false;
        }
      });
    },
    // 搜索商品
    searchPromotionList() {
      this.searchName = this.name;
      this.getPromotionList();
    },
    // 点击停用
    changeStatus(row) {
      let text = "";
      if (row.status === 1) {
        text = "禁用";
      } else {
        text = "启用";
      }
      this.$confirm(`是否${text}该促销规则`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let id = row.id;
          let status = row.status === 1 ? 2 : 1;
          let data = {
            id,
            status
          };
          dbMarketing.postDBUpdatePromotionStatus(data).then(res => {
            if (res.success) {
              row.status = status;
              row.statusValue = status === 1 ? "开启" : "关闭";
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {
          console.log("取消");
        });
    },
    // 点击删除
    deletePromotionGoods(id) {
      this.$confirm("是否确定删除当前商品?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let data = { id };
          dbMarketing.postDBDeletePromotionGoods(data).then(res => {
            if (res.success) {
              this.getPromotionList();
            }
          });
        })
        .catch(() => {
          console.log("取消");
        });
    },
    // 点击查看详情
    toPromotionGoodsDetailById(id) {
      this.$router.push({
        path: "/admin/marketing/promotion/add-promotion",
        query: {
          id: id,
          detail: true
        }
      });
    },
    // 复制当前数据
    copy(id) {
      this.copyId = id
      this.$message.success("复制成功");
    },
    // 修改促销
    toPromotionGoodsUpdateById(id) {
      this.$router.push({
        path: "/admin/marketing/promotion/add-promotion",
        query: {
          id: id
        }
      });
    },
    // 翻页
    onQueryChange(data) {
      this.currentPage = data.currentPage;
      this.getPromotionList();
    },
    openDialogVisible() {
      this.dialogVisible = true;
    },
    cancel() {
      this.dialogVisible = false;
    },
    sevePromotionStatus() {
      let status = this.formData.status;
      dbMarketing.getDBUpdatePromotionDiscount(status).then(res => {
        if (res.success) {
          this.$message.success("修改成功");
          this.dialogVisible = false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.goods-promotion {
  width: 100%;
  height: 100%;
  .goods-promotion-main {
    .add-promotion {
      margin-bottom: 16px;
      .setting {
        margin-left: 16px;
      }
    }
    .search {
      padding: 16px;
      background: rgba(245, 247, 250, 1);
      border-radius: 4px;
      display: flex;
      margin-bottom: 20px;
      .el-input {
        width: 320px;
      }
      .el-button {
        margin-left: 16px;
      }
    }
    .table-img {
      .pagination-tpl-container {
        display: flex;
        justify-content: flex-end;
      }
    }
  }
}
</style>
